module.exports = __webpack_public_path__ + "img/close.5c028a7e81f49e35bce244b041bec84c.svg";